"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.sendAntiTargetingMetrikaGoals = exports.sendAnswersOnQuestions = exports.sendEvent = exports.sendParams = exports.sendReachGoal = exports.getSurveyTitle = exports.getAllCounters = exports.checkAndSendReject = exports.doInitMetrika = exports.getCommonCounter = exports.getQuestionAnswers = exports.getQuestionLabel = exports.INSTRUCTIONS = exports.MESSAGE_NONE_ABOVE = exports.MESSAGE_DIFFICULT_ANSWER = exports.MESSAGE_CUSTOM_OPTION_WITH_TEXT = exports.MESSAGE_CUSTOM_OPTION = void 0;
const effects_1 = require("redux-saga/effects");
const metrika_postman_1 = require("@yandex-int/pythia-libs/lib/metrika-postman");
const question_model_1 = __importDefault(require("@yandex-int/pythia-libs/lib/question-model"));
const markdown_1 = require("src/utils/markdown");
const metrika_1 = require("src/utils/metrika");
const actions_1 = require("../actions");
const selectors_1 = require("./selectors");
exports.MESSAGE_CUSTOM_OPTION = 'Свой вариант';
exports.MESSAGE_CUSTOM_OPTION_WITH_TEXT = 'Свой вариант (с текстом)';
exports.MESSAGE_DIFFICULT_ANSWER = 'Затрудняюсь ответить';
exports.MESSAGE_NONE_ABOVE = 'Ничего из перечисленного';
exports.INSTRUCTIONS = {
    start: {
        message: 'Опрос стартовал',
        goal: 'start'
    },
    finish: {
        message: 'Опрос завершен',
        goal: 'finish'
    },
    screenout: {
        message: 'Опрос завершен (скринаут)',
        goal: 'screenout'
    },
    reject: {
        message: 'Визит после завершения',
        goal: 'reject'
    },
    overflow: {
        message: 'Содержимое опроса не вместилось в экран',
        goal: 'overflow',
        internal: true
    }
};
function getQuestionLabel(question) {
    const model = (0, question_model_1.default)(question);
    const { label = '' } = model.getState();
    return (0, markdown_1.cleaner)(label);
}
exports.getQuestionLabel = getQuestionLabel;
function getQuestionAnswers(question) {
    const model = (0, question_model_1.default)(question);
    const state = model.getState();
    const otherAnswerWithText = state.otherAnswerWithText || {};
    const hasOtherAnswerWithText = otherAnswerWithText.checked && otherAnswerWithText.value;
    const values = model.getValueAsObj();
    const params = [];
    const { options, text } = values;
    if (text) {
        if (hasOtherAnswerWithText) {
            params.push([exports.MESSAGE_CUSTOM_OPTION_WITH_TEXT, text]);
        }
        else {
            params.push(text);
        }
    }
    if (options && options.length) {
        options.forEach(optionIndex => {
            if (optionIndex === -1) {
                params.push(exports.MESSAGE_NONE_ABOVE);
            }
            else if (optionIndex === -2) {
                params.push(exports.MESSAGE_DIFFICULT_ANSWER);
            }
            else if (optionIndex === -3) {
                params.push(exports.MESSAGE_CUSTOM_OPTION);
            }
            else if (optionIndex === -4) {
                // Ничего не отправляем, так как уже отправили в блоке отправки текстового ответа
            }
            else {
                const option = state.options.filter(option => {
                    return String(option.id) === String(optionIndex);
                })[0];
                /**
                 * url - наибольший приоритет, если выбра sbs
                 * label - может быть у choice
                 * id - если нет ни url, ни label (в рейтинге например)
                 */
                const label = option.url || option.label || option.id;
                params.push((0, markdown_1.cleaner)(String(label)));
            }
        });
    }
    return params;
}
exports.getQuestionAnswers = getQuestionAnswers;
function* getCommonCounter() {
    const { metrika } = yield (0, effects_1.select)(selectors_1.getConfig);
    return metrika;
}
exports.getCommonCounter = getCommonCounter;
function* doInitMetrika() {
    const commonCounter = yield (0, effects_1.call)(getCommonCounter);
    yield (0, effects_1.call)(metrika_1.initMetrika, { counter: commonCounter });
    yield (0, effects_1.put)((0, actions_1.initMetrikaCounter)());
}
exports.doInitMetrika = doInitMetrika;
function* checkAndSendReject(action) {
    action.data = action.data || {};
    if (action.data.reason === 'ALREADY_FINISHED') {
        yield (0, effects_1.call)(sendEvent, exports.INSTRUCTIONS.reject);
    }
}
exports.checkAndSendReject = checkAndSendReject;
function* getAllCounters(internal = false) {
    const commonCounter = yield (0, effects_1.call)(getCommonCounter);
    const extraCounters = yield (0, effects_1.select)(selectors_1.getMetrika);
    let counters = [commonCounter];
    if (!internal) {
        counters = counters.concat(extraCounters);
    }
    return counters;
}
exports.getAllCounters = getAllCounters;
function* getSurveyTitle() {
    const slug = yield (0, effects_1.select)(selectors_1.getSlug);
    const title = yield (0, effects_1.select)(selectors_1.getMetrikaTitle);
    if (title) {
        return `${title} (${slug})`;
    }
    return slug;
}
exports.getSurveyTitle = getSurveyTitle;
function* sendReachGoal(goal, internal = false) {
    const counters = yield (0, effects_1.call)(getAllCounters, internal);
    for (const counter of counters) {
        yield (0, effects_1.call)(metrika_postman_1.sendGoalToMetrika, counter, goal);
    }
}
exports.sendReachGoal = sendReachGoal;
function* sendParams(params, internal = false) {
    const counters = yield (0, effects_1.call)(getAllCounters, internal);
    for (const counter of counters) {
        yield (0, effects_1.call)(metrika_postman_1.sendParamsToMetrika, counter, params);
    }
}
exports.sendParams = sendParams;
function* sendEvent(event) {
    const title = yield (0, effects_1.call)(getSurveyTitle);
    const { goal, message, internal } = event;
    yield (0, effects_1.call)(sendReachGoal, goal, internal);
    yield (0, effects_1.call)(sendParams, [title, message], internal);
}
exports.sendEvent = sendEvent;
function* sendAnswersOnQuestions() {
    const title = yield (0, effects_1.call)(getSurveyTitle);
    const currentPage = yield (0, effects_1.select)(selectors_1.getCurrentPage);
    const questionsList = yield (0, effects_1.call)(selectors_1.getQuestionInPage, currentPage);
    for (const question of questionsList) {
        const label = yield (0, effects_1.call)(getQuestionLabel, question);
        const answers = yield (0, effects_1.call)(getQuestionAnswers, question);
        if (answers.length) {
            for (const answer of answers) {
                const params = [title, label];
                if (Array.isArray(answer)) {
                    params.push(...answer);
                }
                else {
                    params.push(answer);
                }
                yield (0, effects_1.call)(sendParams, params);
            }
        }
    }
}
exports.sendAnswersOnQuestions = sendAnswersOnQuestions;
function* sendAntiTargetingMetrikaGoals(eventNames) {
    // [{event: 'finish', counterId: number, goal: string}]
    let metrikaCounters = yield (0, effects_1.select)(selectors_1.getMetrikaCountersData);
    metrikaCounters = (metrikaCounters || []).filter(({ event }) => eventNames.includes(event));
    for (const { counterId, goal } of metrikaCounters) {
        yield (0, effects_1.call)(metrika_postman_1.sendGoalToMetrika, counterId, goal);
    }
}
exports.sendAntiTargetingMetrikaGoals = sendAntiTargetingMetrikaGoals;
function* router() {
    // LANG_SET гарантированно происходит после первого запроса в бекенд, либо при ошибке
    yield (0, effects_1.takeEvery)('LANG_SET', doInitMetrika);
    yield (0, effects_1.takeEvery)('SURVEY_SET_INITED', sendEvent, exports.INSTRUCTIONS.start);
    yield (0, effects_1.takeEvery)('SURVEY_FINISH_SUCCESS', sendEvent, exports.INSTRUCTIONS.finish);
    yield (0, effects_1.takeEvery)('SURVEY_SCREENOUT_SUCCESS', sendEvent, exports.INSTRUCTIONS.screenout);
    yield (0, effects_1.takeEvery)('DETECTED_SCROLL_ON_SURVEY', sendEvent, exports.INSTRUCTIONS.overflow);
    yield (0, effects_1.takeEvery)('SURVEY_GET_FAILURE', checkAndSendReject);
    yield (0, effects_1.takeEvery)('METRIKA_SEND_ANSWERS', sendAnswersOnQuestions);
    yield (0, effects_1.takeEvery)('SURVEY_FINISH_SUCCESS', sendAntiTargetingMetrikaGoals, [
        exports.INSTRUCTIONS.finish.goal
    ]);
    yield (0, effects_1.takeEvery)('SURVEY_SCREENOUT_SUCCESS', sendAntiTargetingMetrikaGoals, [
        exports.INSTRUCTIONS.screenout.goal
    ]);
}
exports.router = router;
